import { FileDownloadRenderer, fileDownloadType } from './FileDownload'

class CustomFormFields {
  static $inject = ['formFields']
  constructor(formFields) {
    // console.log('CustomFormFields constructor:', formFields)
    if (!formFields || typeof formFields.register !== 'function') {
      throw new Error('Invalid formFields object')
    }
    formFields.register(fileDownloadType, FileDownloadRenderer)
  }
  fileDownloadType
}

export default {
  __init__: ['fileDownloadField'],
  fileDownloadField: ['type', CustomFormFields],
}
